export namespace ClaimApprovals {
    export const codes = [
        { Code: "01", Value: "Generic Available" },
        { Code: "02", Value: "Non-Formulary Drug" },
        { Code: "03", Value: "Maintenance Drug" },
        {
            Code: "04",
            Value: "Claim paid under plan's transition benefit period, otherwise claim would have been rejected.",
        },
        {
            Code: "05",
            Value: "Claim paid under the plan's transition benefit period, otherwise claim would have been rejected as prior authorization required.",
        },
        {
            Code: "06",
            Value: "Claim paid under the plan's transition benefit period, otherwise claim would have been rejected as non-formulary drug.",
        },
        {
            Code: "07",
            Value: "Claim paid under plan's transition benefit period, otherwise claim would have been rejected based on plan benefit restrictions.",
        },
        {
            Code: "08",
            Value: "Claim paid under plan's emergency supply benefit, transition benefit did not apply; otherwise claim would have been rejected.",
        },
        {
            Code: "09",
            Value: "Claim paid under plan's emergency supply benefit, transition benefit did not apply; otherwise claim would have been rejected as prior authorization required.",
        },
        {
            Code: "10",
            Value: "Claim paid under plan's emergency supply benefit, transition benefit did not apply; otherwise claim would have been rejected as non-formulary drug.",
        },
        {
            Code: "11",
            Value: "Claim paid under plan's emergency supply benefit, transition benefit did not apply; otherwise claim would have been rejected due to plan benefit restrictions.",
        },
        {
            Code: "12",
            Value: "Claim paid under plan's level of care change benefit, otherwise claim would have rejected.",
        },
        {
            Code: "13",
            Value: "Claim paid under plan's level of care change benefit, otherwise claim would have rejected for prior authorization required.",
        },
        {
            Code: "14",
            Value: "Claim paid under plan's level of care change benefit, otherwise claim would have rejected for non-formulary drug.",
        },
        {
            Code: "15",
            Value: "Claim paid under plan's level of care change benefit, otherwise claim would have rejected due to plan benefit restrictions.",
        },
        { Code: "16", Value: "PMP Reportable Required" },
        { Code: "17", Value: "PMP Reporting Completed" },
        {
            Code: "18",
            Value: "Provide Notice: Medicare Prescription Drug Coverage and Your Rights",
        },
        {
            Code: "19",
            Value: "The Submitted Prescriber ID is inactive or expired - Flagged for Retrospective Review",
        },
        {
            Code: "20",
            Value: "Prescriber DEA number is not found in processor's system. Paid claim flagged for retrospective review.",
        },
        {
            Code: "21",
            Value: "Prescriber DEA number in the processor's system is inactive/expired. Paid claim flagged for retrospective review.",
        },
        {
            Code: "22",
            Value: "Prescriber DEA number in the processor's system does not allow for this drug DEA schedule. Paid claim flagged for retrospective review.",
        },
        {
            Code: "23",
            Value: "Prorated copayment applied. Plan has prorated the copayment based on quantity or days supply.",
        },
        {
            Code: "24",
            Value: "The submitted Prescriber ID is Not Found - Flagged for Retrospective Review",
        },
        {
            Code: "25",
            Value: "The submitted Prescriber ID is associated to a Deceased Prescriber - Flagged for Retrospective Review",
        },
        {
            Code: "26",
            Value: "Prescriber Type 1 NPI Required - Flagged for Retrospective Review",
        },
        {
            Code: "27",
            Value: "The submitted Prescriber DEA does not allow this drug DEA Schedule - Flagged for Retrospective Review",
        },
        {
            Code: "29",
            Value: "Grace period claim. Patient required to pay for the full cost of the prescription.",
        },
        {
            Code: "32",
            Value: "Plan's Prescriber database not able to verify active state license with prescriptive authority for Prescriber ID Submitted, flagged for retrospective review.",
        },
        {
            Code: "33",
            Value: "Hospice Compassionate First Initial Dispensing",
        },
        { Code: "34", Value: "Prior Authorization Approval On File" },
        { Code: "35", Value: "Quantity Limit Per Specific Time Period" },
        { Code: "36", Value: "Days Supply Limit Per Specific Time Period" },
        { Code: "37", Value: "Preferred Formulary Alternative Available" },
        { Code: "38", Value: "Preferred Network Pharmacy" },
        { Code: "39", Value: "Non-Preferred Network Pharmacy" },
        {
            Code: "40",
            Value: "Specialty Pharmacy Network Available For This Medication",
        },
        {
            Code: "44",
            Value: "Plan's Prescriber database determined prescriptive authority criteria not met, flagged for retrospective review.",
        },
        {
            Code: "45",
            Value: "Prescriber active enrollment with Medicaid Fee For Service/MCO required. Flagged for retrospective review.",
        },
        {
            Code: "46",
            Value: "Pharmacy active enrollment with Medicaid Fee For Service/MCO required. Flagged for retrospective review.",
        },
        { Code: "47", Value: "Result of Service Code Accepted" },
        { Code: "48", Value: "Diagnosis Code Accepted" },
        {
            Code: "49",
            Value: "Drug Discount Program Pricing Applied due to Plan Benefit Reject or Formulary Exclusion Reject",
        },
        {
            Code: "50",
            Value: "Drug Discount Program Pricing Applied due to Plan Patient Eligibility Reject",
        },
        { Code: "51", Value: "POS Rebate Applied" },
        {
            Code: "52",
            Value: "POS Rebate Applied; Separate Chargeback Administrator",
        },
        {
            Code: "53",
            Value: "Drug/Product covered; Professional Service not covered",
        },
        {
            Code: "54",
            Value: "PGx: Pharmacogenetic Testing is required before future fills will be allowed.",
        },
        {
            Code: "55",
            Value: "Reversal accepted, but Reconciliation ID (B98-34) of reversed transaction does not match the Reconciliation ID (B98-34) submitted on the reversal.",
        },
        {
            Code: "56",
            Value: "Beneficiary likely to benefit from Medicare Prescription Payment Plan.",
        },
        {
            Code: "57",
            Value: "Beneficiary participating in Medicare Prescription Payment Plan",
        },
        {
            Code: "58",
            Value: "Beneficiary is no longer a participant in the Medicare Prescription Payment Plan due to voluntary or involuntary termination.",
        },
        {
            Code: "59",
            Value: "Due to patient savings opportunity, claim adjudicated by drug discount program. Accumulators reported.",
        },
        {
            Code: "60",
            Value: "Temporary Coverage Allowed Under a Limited DUR Override",
        },
        {
            Code: "61",
            Value: "Claim eligible for Medicare Drug Price Negotiation Program for Maximum Fair Price (MFP)",
        },
        {
            Code: "62",
            Value: 'Submitted claim indicates Unknown Delivery Device Method; may be flagged for retrospective review. Result of Service Code (441-E6) value of "Unknown Delivery Device Method and Immediate Access Required" may not be supported on future fills.',
        },
    ];
}
